import { apiSlice } from "./apiSlice";

export const adminDataApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    landingPage: builder.query({
      query: () => ({
        url: "/getalllanding",
        method: "GET",
      }),
      keepUnusedDataFor: 5,
    }),
  }),
});

export const { useLandingPageQuery } = adminDataApiSlice;
